import { ViewingsDispatchRequest } from "@/schemas";
import { FormattedMessage } from "react-intl";
import { VIEWINGS_DISPATCH_FLAG_CLASSNAMES } from "../dispatchActions";

const FLAG_CONFIG = [
  "noMatch",
  "waitingOver48h",
  "acceptedAfterDeadline",
  "reassignedInvalidation",
] as const;

export default function ViewingFlags({
  request,
}: {
  request: ViewingsDispatchRequest;
}) {
  const activeFlags = FLAG_CONFIG.filter((flag) => request.flags[flag]);

  if (activeFlags.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 text-xs">
      {activeFlags.map((flag) => (
        <span key={flag} className={VIEWINGS_DISPATCH_FLAG_CLASSNAMES[flag]}>
          <FormattedMessage id={`viewings.flag.${flag}`} />
        </span>
      ))}
    </div>
  );
}
